<div hlmSidebarWrapper>
    <hlm-sidebar collapsible="icon">
        <div hlmSidebarHeader>
            <ul hlmSidebarMenu>
                <li hlmSidebarMenuItem>
                    <a
                        hlmSidebarMenuButton
                        size="lg"
                        routerLink="/dashboard"
                        tooltip="Rozcestník"
                        aria-label="Rozcestník"
                        [closeMobileSidebarOnClick]="true"
                    >
                        @if (isLoading()) {
                            <hlm-skeleton data-sidebar-skeleton class="size-8 shrink-0" aria-hidden="true" />
                        } @else if (currentLogo$ | async; as logoSrc) {
                            <img [src]="logoSrc" class="size-8 shrink-0 object-contain" alt="Logo společnosti" />
                        } @else {
                            <span class="bg-primary text-primary-foreground flex size-8 shrink-0 items-center justify-center rounded-md font-semibold">P</span>
                        }
                    </a>
                </li>
            </ul>
        </div>

        <div hlmSidebarContent>
            <nav class="flex flex-col gap-2" aria-label="Hlavní navigace">
                <div hlmSidebarGroup>
                    <div hlmSidebarGroupContent>
                        <ul hlmSidebarMenu>
                            @if (isLoading()) {
                                @for (itemId of navigation.mainSkeletonItemIds; track itemId) {
                                    <li hlmSidebarMenuItem>
                                        <div data-sidebar-skeleton class="flex h-8 items-center gap-2 rounded-md px-2" aria-hidden="true">
                                            <hlm-skeleton class="size-4 shrink-0" />
                                            <hlm-skeleton class="h-4 w-2/3 group-data-[collapsible=icon]:hidden" />
                                        </div>
                                    </li>
                                }
                            } @else {
                                @for (item of navigation.mainItems(); track item.id) {
                                    @if (item.kind === 'route') {
                                        @if (item.submenu; as submenu) {
                                            <li hlmSidebarMenuItem hlmCollapsible class="group/collapsible" [expanded]="navigation.isActive(item) && (sidebar.isMobile() || sidebar.state() === 'expanded')">
                                                <button
                                                    type="button"
                                                    hlmSidebarMenuButton
                                                    hlmCollapsibleTrigger
                                                    [isActive]="navigation.isActive(item)"
                                                    [tooltip]="item.label"
                                                    (click)="expandSidebarIfCollapsed()"
                                                >
                                                    <ng-icon [name]="item.icon" />
                                                    <span>{{ item.label }}</span>
                                                    <ng-icon name="lucideChevronDown" class="ms-auto transition-transform group-data-[state=open]/collapsible:rotate-180 group-data-[collapsible=icon]:hidden" />
                                                </button>
                                                <hlm-collapsible-content
                                                    class="block overflow-hidden group-data-[collapsible=icon]:hidden data-[state=closed]:block data-[state=closed]:h-0 data-[state=open]:h-(--brn-collapsible-content-height) motion-safe:transition-[height] motion-safe:duration-200 motion-safe:ease-in-out"
                                                >
                                                    <ul hlmSidebarMenuSub>
                                                        @for (subitem of submenu; track subitem.route) {
                                                            @if (navigation.isSubmenuVisible(subitem, user()?.activeCompany?.id)) {
                                                                <li hlmSidebarMenuSubItem>
                                                                    <a
                                                                        hlmSidebarMenuSubButton
                                                                        [routerLink]="subitem.route"
                                                                        [isActive]="navigation.isSubmenuActive(subitem.route)"
                                                                        [attr.aria-current]="navigation.isCurrentRoute(subitem.route) ? 'page' : null"
                                                                        [closeMobileSidebarOnClick]="true"
                                                                        (click)="onSubmenuClick(item.id)"
                                                                    >
                                                                        <span>{{ subitem.label }}</span>
                                                                    </a>
                                                                </li>
                                                            }
                                                        }
                                                    </ul>
                                                </hlm-collapsible-content>
                                            </li>
                                        } @else {
                                            <li hlmSidebarMenuItem>
                                                <a
                                                    hlmSidebarMenuButton
                                                    [routerLink]="item.route"
                                                    [isActive]="navigation.isActive(item)"
                                                    [tooltip]="item.label"
                                                    [attr.aria-label]="item.label"
                                                    [attr.aria-current]="navigation.isActive(item) ? 'page' : null"
                                                    [closeMobileSidebarOnClick]="true"
                                                >
                                                    <ng-icon [name]="item.icon" />
                                                    <span>{{ item.label }}</span>
                                                </a>
                                            </li>
                                        }
                                    }
                                }
                            }
                        </ul>
                    </div>
                </div>

                <div hlmSidebarGroup>
                    <div hlmSidebarGroupLabel>Služby</div>
                    <div hlmSidebarGroupContent>
                        <ul hlmSidebarMenu>
                            @if (isLoading()) {
                                @for (itemId of navigation.serviceSkeletonItemIds; track itemId) {
                                    <li hlmSidebarMenuItem>
                                        <div data-sidebar-skeleton class="flex h-8 items-center gap-2 rounded-md px-2" aria-hidden="true">
                                            <hlm-skeleton class="size-4 shrink-0" />
                                            <hlm-skeleton class="h-4 w-2/3 group-data-[collapsible=icon]:hidden" />
                                        </div>
                                    </li>
                                }
                            } @else {
                                @for (item of navigation.serviceItems(); track item.id) {
                                    <li hlmSidebarMenuItem>
                                        <button
                                            type="button"
                                            hlmSidebarMenuButton
                                            [tooltip]="item.label"
                                            [attr.aria-label]="item.label"
                                            [closeMobileSidebarOnClick]="true"
                                            (click)="navigation.activate(item)"
                                        >
                                            <ng-icon [name]="item.icon" />
                                            <span>{{ item.label }}</span>
                                        </button>
                                    </li>
                                }
                            }
                        </ul>
                    </div>
                </div>
            </nav>
        </div>

        <div hlmSidebarFooter>
            @if (isLoading()) {
                <div data-sidebar-skeleton class="flex h-12 items-center gap-2 px-2" aria-hidden="true">
                    <hlm-skeleton class="size-8 shrink-0 rounded-full" />
                    <div class="grid min-w-0 flex-1 gap-1.5 group-data-[collapsible=icon]:hidden">
                        <hlm-skeleton class="h-3.5 w-24" />
                        <hlm-skeleton class="h-3 w-32" />
                    </div>
                </div>
            } @else {
                <app-user-menu [user]="user()" />
            }
        </div>
    </hlm-sidebar>

    <ng-content />
</div>
